/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetMailingStatusRequest
 */
export interface SetMailingStatusRequest {
    /**
     * 
     */
    status: SetMailingStatusRequestStatusEnum;
}


/**
 * @export
 */
export const SetMailingStatusRequestStatusEnum = {
    Enabled: 'enabled',
    Disabled: 'disabled',
} as const;
export type SetMailingStatusRequestStatusEnum = typeof SetMailingStatusRequestStatusEnum[keyof typeof SetMailingStatusRequestStatusEnum];


/**
 * Check if a given object implements the SetMailingStatusRequest interface.
 */
export function instanceOfSetMailingStatusRequest(value: object): value is SetMailingStatusRequest {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function SetMailingStatusRequestFromJSON(json: any): SetMailingStatusRequest {
    return SetMailingStatusRequestFromJSONTyped(json, false);
}

export function SetMailingStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetMailingStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
    };
}

export function SetMailingStatusRequestToJSON(json: any): SetMailingStatusRequest {
    return SetMailingStatusRequestToJSONTyped(json, false);
}

export function SetMailingStatusRequestToJSONTyped(value?: SetMailingStatusRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
    };
}

